<a [ngSwitch]="value">
  <nz-tag *ngSwitchCase="'Sent'" [nzColor]="'processing'" nz-tooltip [nzTooltipTitle]="'Document has been sent to Peppol network'">Sent</nz-tag>
  <nz-tag *ngSwitchCase="'Cleared'" [nzColor]="'success'" nz-tooltip [nzTooltipTitle]="'Document has been cleared by LHDNM'">Cleared</nz-tag>
  <nz-tag *ngSwitchCase="'Failed'" [nzColor]="'error'" nz-tooltip [nzTooltipTitle]="'Document processing failed'">Failed</nz-tag>
  <nz-tag *ngSwitchCase="'Succeeded'" [nzColor]="'success'" nz-tooltip [nzTooltipTitle]="'Document has been successfully sent to receiver'">Succeeded</nz-tag>
  <!-- <nz-tag *ngSwitchDefault>{{ value ? value : 'No Action Taken' }}</nz-tag> -->
</a>
